enum BusinessStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  CONFIRMED = 'CONFIRMED',
  ADMISSIBLE = 'ADMISSIBLE',
  SCHEDULED_APPOINTMENT = 'SCHEDULED_APPOINTMENT',
  SIGNED_MANDATE = 'SIGNED_MANDATE',
  BANK_SENT = 'BANK_SENT',
  CUSTOMER_FEEDBACK = 'CUSTOMER_FEEDBACK',
  OFFER_EDITED = 'OFFER_EDITED',
  OFFER_SINGNED = 'OFFER_SINGNED',
  CLOSED = 'CLOSED',
  COMMISSION_PAYED = 'COMMISSION_PAYED',
  PENDING_PROJECT = 'PENDING_PROJECT',
  CANCELED = 'CANCELED',
  REDIRECTED = 'REDIRECTED',
  REJECTED = 'REJECTED',
}

export default BusinessStatus;
